import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const StarWrapper = styled.div`
  display: inline-flex;
  font-size: 3rem;
`

const Stars = styled.div`
  margin-right: 0.5rem;
  padding-bottom: 1rem;
  color: gold;
`

const DownloadsWrapper = styled.div`
`

const Downloads = styled.div`
  display: inline-flex;
  margin: 0px auto;
  grid-gap: 1em;
  margin-top: 2em;
  margin-bottom: 2em;
  flex-wrap: wrap;
  max-width: 540px;
`

const Download = styled.a`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  font-size: 1rem;
  max-width: 100%;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  word-break: break-all;
  svg {
    font-size: 3rem;
    margin-right: 1rem;
    color: #151515;
  }
`

const Heading2 = styled.h2`
  display: inline-block;
  width: 100%;
`

const ResultWrapper = styled.div`
  text-align: center;
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  height: 100%;
`

const ResultBody = styled.div`
  flex-grow: 1;
`

const ResultHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  text-align: center;
  align-content: center;
  align-items: center;
  padding-top: 1rem;
`

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px;
  max-width: 600px;
  margin: 0px auto;
  margin-bottom: 1rem;
`

const InfoField = styled.div`
  font-size: 1rem;
  border: 1px solid gainsboro;
  padding: 0.25rem 0.5rem;
  display: flex;
  justify-content: space-between;
  span {
    font-weight: bold;
  }
`

const Warning = styled.div`
  background: #f2dede;
  border: 1px solid #ffadad;
  padding: 1rem;
  margin: 0 15rem;
  border-radius: 5px;
`

const ResultText = styled.div`
  .trix-content {
    font-size: 1.3rem;
    @media (min-width: 768px) {
      font-size: 1.6rem;
    }
    p {
      font-size: 1.3rem;
      @media (min-width: 768px) {
        font-size: 1.6rem;
      }
    }
  }
  max-width: 900px;
  margin: 0px auto;
  text-align: center;
`

export default class QuizAttemptCompleted extends React.Component {
  render() {
    let { quiz_attempt } = this.props
    let percentage = Math.round((quiz_attempt.points_awarded / quiz_attempt.total_possible_points) * 10000)
    let percentageString = String(percentage)
    let starArray = ['', '', '', '', '']
    let starRank = (
      <Stars>
        {
          starArray.map((val, i) => {
            if (percentage >= 2000 * (i + 1)) {
              return (<i className="fas fa-star" key={i}/>)
            } else if (percentage % 2000 != 0 && percentage >= 2000 * (i)) {
              return (<i className="fas fa-star-half-alt" key={i}/>)
            } else {
              return (<i className="far fa-star" key={i}/>)
            }
          })
        }
      </Stars>
    )
    let downloads = (
      <Downloads>
        {
          quiz_attempt.quiz.downloads.map((download, i) => {
            if (download[0] == 'application/pdf') {
              return (<Download target="_blank" href={download[2]} key={i}><i className="fas fa-file-pdf"/>{ download[1] }</Download>)
            } else if (download[0] == 'application/mswordf' || download[0] == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
              return (<Download target="_blank" href={download[2]} key={i}><i className="fas fa-file-word"/>{ download[1] }</Download>)
            } else if (download[0] == 'application/vnd.ms-excel' || download[0] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
              return (<Download target="_blank" href={download[2]} key={i}><i className="fas fa-file-excel"/>{ download[1] }</Download>)
            } else if (download[0] == 'application/vnd.ms-powerpoint' || download[0] == 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
              return (<Download target="_blank" href={download[2]} key={i}><i className="fas fa-file-powerpoint"/>{ download[1] }</Download>)
            } else if (download[0] == 'image/jpeg' || download[0] == 'image/gif' || download[0] == 'image/png') {
              return (<Download target="_blank" href={download[2]} key={i}><i className="fas fa-file-image"/>{ download[1] }</Download>)
            } else {
              return (<Download target="_blank" href={download[2]} key={i}><i className="fas fa-file"/>{ download[1] }</Download>)
            }
          })
        }
      </Downloads>
    )

    if (!quiz_attempt.complete_set) {
      return (
        <ResultWrapper>
          <ResultHeader>
            <Heading2>
              { quiz_attempt.quiz.title } - Could not play
            </Heading2>
          </ResultHeader>
          <ResultBody>
            <Warning>
              There are not enough remaining questions to play this quiz.
            </Warning>
          </ResultBody>
        </ResultWrapper>
      )
    }

    return (
      <ResultWrapper>
        <ResultHeader>
          <Heading2>
            { quiz_attempt.quiz.title } - Completed
          </Heading2>
        </ResultHeader>
        <ResultBody>
          {
            quiz_attempt.quiz.show_results_page_after_quiz
              ? (
                <div>
                  <StarWrapper>
                    { starRank }
                  </StarWrapper>
                  <InfoGrid>
                    <InfoField>
                      <span>Percent Score:</span> { percentageString.substr(0, percentageString.length - 2) + '.' + percentageString.substr(percentageString.length - 2,percentageString.length) + '%' }
                    </InfoField>
                    <InfoField>
                      <span>Pass:</span> { quiz_attempt.success ? 'Yes' : 'No' }
                    </InfoField>
                    <InfoField>
                      <span>Points Awarded:</span> { quiz_attempt.points_awarded } / { quiz_attempt.total_possible_points }
                    </InfoField>
                    <InfoField>
                      <span>Answered Correctly:</span> { quiz_attempt.answered_correctly } / { quiz_attempt.total_questions }
                    </InfoField>
                    {
                      quiz_attempt.timed_out
                        ? (
                          <InfoField>
                            <span>Ran Out Of Time?</span> Yes
                          </InfoField>
                        )
                        : null
                    }
                  </InfoGrid>
                  {
                    quiz_attempt.success
                      ? (<ResultText dangerouslySetInnerHTML={{ __html: quiz_attempt.quiz.pass_completion_message }}/>)
                      : null
                  }
                  {
                    !quiz_attempt.success && quiz_attempt.quiz.fail_completion_message
                      ? (<ResultText dangerouslySetInnerHTML={{ __html: quiz_attempt.quiz.fail_completion_message }}/>)
                      : null
                  }
                  {
                      quiz_attempt.quiz.downloads.length > 0
                        ? (
                          <DownloadsWrapper>
                            { downloads }
                          </DownloadsWrapper>
                        )
                        : null
                    }
                </div>
              )
              : null
          }
        </ResultBody>
      </ResultWrapper>
    )
  }
}
